import React, { FC, PropsWithChildren } from 'react';
import { InlineErrorBoundary } from '@v2/components/errorBoundary';
import PerformanceScreenErrorFallback from './PerformanceScreenErrorFallback';

interface PerformanceScreenNetProps extends PropsWithChildren {
  screenName?: string;
}

// Screen-level error net shared by both performance surfaces: catches content crashes while keeping the
// surrounding chrome, rendering the chart-block-width fallback.
const PerformanceScreenNet: FC<PerformanceScreenNetProps> = ({ screenName, children }) => (
  <InlineErrorBoundary screenName={screenName} FallbackComponent={PerformanceScreenErrorFallback}>
    {children}
  </InlineErrorBoundary>
);

export default PerformanceScreenNet;
